import { action } from 'typesafe-actions';
import {
  AtendimentosTypes,
  Atendimento,
  IFiltroAtendimentos,
  Pagination,
  IFilter,
  Sorter,
} from './types';

export const loadRequest = (
  filter: IFilter | any,
  inscricaoAtiva: number[],
  cddAtivo: number,
  pagination?: Pagination,
  sorter?: Sorter
) =>
  action(AtendimentosTypes.LOAD_REQUEST, { filter, inscricaoAtiva, cddAtivo, pagination, sorter });

export const loadSuccess = (data: Atendimento[], pagination: Pagination) =>
  action(AtendimentosTypes.LOAD_SUCCESS, { data, pagination });

export const loadFailure = () => action(AtendimentosTypes.LOAD_FAILURE);

export const filterAtendimentos = (filter: IFiltroAtendimentos) =>
  action(AtendimentosTypes.FILTER_ATENDIMENTOS, { filter });

export const sorterAtendimentos = (ordenacao: any) =>
  action(AtendimentosTypes.SORTER_ATENDIMENTOS, { ordenacao });

export const cleanStateAtendimentos = () => action(AtendimentosTypes.CLEAN_ATENDIMENTOS);
